import React from 'react';
import { withNamespaces } from 'react-i18next';
import { observer, inject } from 'mobx-react';

import { analytics } from 'core/analytics';
import { staticURL } from 'core/url';
import Header from 'apps/components/header/header';
import DocumentHead from 'legacyComponents/documentHead';

@withNamespaces()
@inject('routerStore')
@observer
export class MarketplacePage extends React.Component {
  constructor() {
    super();
    // this.appManager = new LandingAppManager(null, {});
    analytics.sendEvent('ViewContent', {}, { twitter: true, facebook: true });
    analytics.linkedinPixel('1169129');
  }

  render() {
    return (
      <>
        <DocumentHead imagePath={staticURL('assets/wikifactory.jpg')} />
        <Header />
        ...marketplace landing goes here.
      </>
    );
  }
}
